import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface VolcesJimeng30Params {
  /**
   * 提示词，必填，长度必须在1-800个字符之间
   */
  prompt: string;
  /**
   * 是否使用预处理LLM，默认值为true
   * @default true
   */
  use_pre_llm?: boolean;
  /**
   * 随机种子，-1或正整数，默认值为-1
   * @default -1
   */
  seed?: number;
  /**
   * 图像宽度，范围512-2048，默认值为1328
   * @default 1328
   */
  width?: number;
  /**
   * 图像高度，范围512-2048，默认值为1328
   * @default 1328
   */
  height?: number;
}

export interface VolcesJimeng30Resource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * volces_jimeng_3_0
 *
 * 通过火山即梦3.0 API创建图像生成任务。[API Documentation](https://www.volcengine.com/docs/85621/1616429)
 *
 * @example
 * ```typescript
 * import { initSeacloud, volcesJimeng30 } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await volcesJimeng30({
 *   // 参数见 VolcesJimeng30Params 接口定义
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 VolcesJimeng30Params 接口定义
 * @returns 生成的资源列表
 */
export async function volcesJimeng30(
  params: VolcesJimeng30Params,
): Promise<VolcesJimeng30Resource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'volces_jimeng_3_0',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: VolcesJimeng30Resource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
